import React from "react";
import { ReactComponent as GoogleIcon } from "../../inlineSvgs/google.svg";

const googleClientId = process.env.REACT_APP_GOOGLE_APP_ID;

const GOOGLE_AUTH = `https://accounts.google.com/o/oauth2/auth?client_id=${googleClientId}&redirect_uri=${window.location.origin}/auth/google-callback&scope=openid+profile+email+https://www.googleapis.com/auth/user.phonenumbers.read&response_type=code`;

const GoogleLogIn = () => {
  return (
    <a href={GOOGLE_AUTH} className="beauty-btn border with-icon">
      <GoogleIcon /> <span>Login using Google</span>
    </a>
  );
};

export default GoogleLogIn;
